import React from "react";
import ReactPaginate from "react-paginate";
import useQueryParams from "../hooks/useQueryParams";

export const PaginationWithQueryState = ({ totalPages = 10, ...res }) => {
  const { params, addOrUpdateParams, removeParam } = useQueryParams();

  const currentPage = params.page ? parseInt(params.page) : 1;

  return (
    <ReactPaginate
      previousLabel={<i className="fal fa-chevron-left" />}
      breakLabel="..."
      nextLabel={<i className="fal fa-chevron-right" />}
      breakClassName={"break-me"}
      forcePage={currentPage - 1}
      pageCount={totalPages}
      marginPagesDisplayed={2}
      pageRangeDisplayed={5}
      onPageChange={({ selected }) => addOrUpdateParams({ page: selected + 1 })}
      containerClassName={"pagination"}
      {...res}
    />
  );
};

export default PaginationWithQueryState;
